import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import State from '../states'
import Toolbar, { Props } from '../components/Toolbar'
import { MediaInput, Toolbar as Actions } from '../actions'

const mapStateToProps = (_state: State): Partial<Props> => ({})

const mapDispatchToProps = (dispatch: Dispatch<State>): Partial<Props> => ({
  onSelectPhoto: (photo: string) => {
    dispatch(MediaInput.selectPhoto(photo))
  },
  onViewDialogue: () => {
    dispatch(Actions.toggleDialogue())
  },
  onViewInformation: () => {
    dispatch(Actions.showInfoModal())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Toolbar.ts